import * as topojson from 'topojson-client'

import { PROJECTION_TYPES } from './constants'
import { BaseMap } from './base-map'
import usTopology from './topology/us-states.json'
import letterCodes from './topology/us-states-letter-codes.json'
import { TooltipContextProvider } from '../common/tooltip/tooltip.context'

const topology = getStateTopology(usTopology)

const DEFAULT_WIDTH = 1024
const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1
const alignValue = isFirefox ? '-moz-center' : '-webkit-center'

export const UsMap = ({ useLetterCodes = false, width = DEFAULT_WIDTH, height = width / (DEFAULT_WIDTH / 550), mapKeyPosition, ...props }) => {
  const legendProperties = width <= 887 ? {
    bottom: (height / 3.5), // When height is 550, this is bottom: 100px
    left: (width / 1.24), // When width is 1024, this is left: 800px
    position: 'unset',
    textAlign: alignValue
  } : {
    bottom: (height / 3.5), // When height is 550, this is bottom: 100px
    left: (width / 1.24) // When width is 1024, this is left: 800px
  }
  // Key is absolutely positioned within the div wrapper around the SVG
  mapKeyPosition = mapKeyPosition || legendProperties
  const mapRegionInfo = (x) => ({
    code: useLetterCodes ? letterCodes[x.id] : x.id,
    name: x.properties.name
  })
  return (
    <TooltipContextProvider>
      <BaseMap
        width={width}
        height={height}
        projectionType={PROJECTION_TYPES.ALBERS_USA}
        topology={topology}
        mapRegionInfo={mapRegionInfo}
        regionLabel="state"
        projectionProps={{
          scale: 1200,
          translate: [ 500, 290 ]
        }}
        mapKeyPosition={mapKeyPosition}
        {...props}
      />
    </TooltipContextProvider>
  )
}

function getStateTopology (topoJsonTopology) {
  const stateTopology = topojson.feature(topoJsonTopology, topoJsonTopology.objects.states)
  const excludeFeatures = [
    '11', // District of Columbia
    '60', // American Samoa
    '66', // Guam
    '69', // Commonwealth of the Northern Mariana Islands
    '72', // Puerto Rico
    '78' // United States Virgin Islands
  ]
  stateTopology.features = stateTopology.features.filter((f) => !excludeFeatures.includes(f.id))
  return stateTopology
}
